import { apiClient, getToken, getOrgId } from '@devd-client/api';

export const deleteGoal = (goalId: string): Promise<any> =>
  apiClient(`/v1/goals/org/${getOrgId()}/${goalId}`, {
    method: 'DELETE',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
